import { render, staticRenderFns } from "./accountsManage.vue?vue&type=template&id=5400de8a&scoped=true&"
import script from "./accountsManage.vue?vue&type=script&lang=js&"
export * from "./accountsManage.vue?vue&type=script&lang=js&"
import style0 from "./accountsManage.vue?vue&type=style&index=0&id=5400de8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400de8a",
  null
  
)

export default component.exports